import CNRRanges from "components/app/report/comprehensive-noon-report/cnr-ranges/CNRRanges";
import React from "react";

type ScreenCNRRangesProps = React.PropsWithChildren<{}>;

function ScreenCNRRanges(props: ScreenCNRRangesProps) {
	return <CNRRanges />
}
export default ScreenCNRRanges;